/**
 * Vietnamese translations for User Guide feature
 */
export default {
  // Help Center
  helpCenter: {
    title: "Trung tâm hỗ trợ",
    search: "Tìm kiếm trợ giúp...",
    gettingStarted: "Bắt đầu",
    featureGuides: "Hướng dẫn tính năng",
    quickReference: "Tham khảo nhanh",
    contactSupport: "Liên hệ hỗ trợ",
    noResults: "Không tìm thấy kết quả",
    allGuidesComplete: "Đã hoàn thành tất cả hướng dẫn!",
    progress: "Tiến độ",
    resetProgress: "Đặt lại tiến độ",
    resetConfirm: "Bạn có chắc muốn đặt lại tất cả tiến độ hướng dẫn?",
  },

  // Onboarding Welcome
  onboarding: {
    welcome: {
      title: "Chào mừng bạn đến với hệ thống!",
      subtitle:
        "Hãy bắt đầu với một chuyến tham quan nhanh các tính năng chính",
      startTour: "Bắt đầu hướng dẫn",
      exploreLater: "Tôi sẽ tự khám phá",
      dontShowAgain: "Không hiển thị lại",
    },
    progress: {
      title: "Tiến độ của bạn",
      completed: "{{completed}} / {{total}} hoàn thành",
    },
    checklist: {
      title: "Danh sách bắt đầu",
      viewDashboard: "Xem trang tổng quan",
      manageRecords: "Tạo hoặc chỉnh sửa bản ghi",
      completeTask: "Hoàn thành công việc",
      importData: "Nhập dữ liệu từ file",
      customizeTable: "Tùy chỉnh cột bảng",
    },
  },

  // Page Tour Button
  pageTour: {
    startTooltip: "Xem hướng dẫn sử dụng trang này",
    replayTooltip: "Xem lại hướng dẫn trang này",
  },

  // Tour Definitions
  tours: {
    // Common messages
    common: {
      elementsNotFound: "Không tìm thấy phần tử cần hướng dẫn trên trang này",
      completed: "Hoàn thành hướng dẫn!",
    },
    // Workflow/InBasket Tour
    workflowInbasket: {
      title: "Quản lý công việc",
      description: "Tìm hiểu cách xem và duyệt công việc trong hệ thống",
      steps: {
        taskList: {
          title: "Danh sách công việc",
          description:
            "Đây là hộp thư công việc của bạn. Tất cả công việc chờ xử lý được giao cho bạn sẽ xuất hiện ở đây. Bạn có thể xem chi tiết, nguồn và thời hạn.",
        },
        viewModes: {
          title: "Chế độ xem",
          description:
            "Chuyển đổi giữa chế độ bảng và thẻ bằng các nút này. Chế độ thẻ trực quan hơn, trong khi chế độ bảng hiển thị nhiều thông tin hơn.",
        },
        filters: {
          title: "Lọc công việc",
          description:
            "Sử dụng bộ lọc để tìm công việc cụ thể. Bạn có thể lọc theo loại, nguồn hoặc khoảng thời gian.",
        },
        completeTask: {
          title: "Hoàn thành công việc",
          description:
            "Nhấp nút 'Duyệt' để mở hộp thoại hoàn thành. Đây là nơi bạn đưa ra quyết định.",
        },
        selectPath: {
          title: "Chọn đường dẫn",
          description:
            "Chọn đường dẫn quy trình phù hợp. Mỗi đường dẫn đại diện cho một quyết định khác nhau (ví dụ: Duyệt, Từ chối, Yêu cầu sửa đổi).",
        },
        addComments: {
          title: "Thêm ghi chú",
          description:
            "Tùy chọn thêm ghi chú để giải thích quyết định. Ghi chú sẽ hiển thị cho người dùng khác trong lịch sử quy trình.",
        },
      },
    },

    // Entity Management Tour
    entityManagement: {
      title: "Quản lý bản ghi",
      description:
        "Tìm hiểu cách tạo, xem và chỉnh sửa các bản ghi như Khách hàng tiềm năng, Khách hàng và Cơ hội",
      steps: {
        navigation: {
          title: "Điều hướng",
          description:
            "Sử dụng thanh bên để di chuyển giữa các loại bản ghi. Nhấp vào bất kỳ loại nào để xem danh sách.",
        },
        listView: {
          title: "Xem danh sách",
          description:
            "Duyệt tất cả bản ghi trong bảng có thể sắp xếp và lọc. Nhấp vào tiêu đề cột để sắp xếp, hoặc dùng ô tìm kiếm.",
        },
        createNew: {
          title: "Tạo bản ghi mới",
          description:
            "Nhấp nút 'Tạo mới' để thêm bản ghi. Một biểu mẫu sẽ mở ra để bạn nhập thông tin.",
        },
        importData: {
          title: "Nhập dữ liệu từ Excel",
          description:
            "Nhấp nút 'Nhập dữ liệu' để nhập hàng loạt bản ghi từ tệp Excel hoặc CSV. Tải mẫu, điền dữ liệu và tải lên.",
        },
        fillForm: {
          title: "Điền biểu mẫu",
          description:
            "Nhập thông tin cần thiết vào các trường. Các trường bắt buộc được đánh dấu (*). Các phần giúp tổ chức các trường liên quan.",
        },
        viewDetails: {
          title: "Xem chi tiết",
          description:
            "Nhấp vào bất kỳ bản ghi nào để xem đầy đủ chi tiết, bao gồm các mục liên quan và lịch sử.",
        },
        editRecord: {
          title: "Chỉnh sửa bản ghi",
          description:
            "Nhấp nút 'Sửa' để thay đổi thông tin. Đừng quên lưu các thay đổi!",
        },
        relatedItems: {
          title: "Các mục liên quan",
          description:
            "Xem và quản lý các mục liên quan bằng các tab ở phía dưới. Bạn có thể thêm liên kết mới hoặc điều hướng đến các bản ghi liên quan.",
        },
      },
    },

    // Import Wizard Tour
    importWizard: {
      title: "Nhập dữ liệu",
      description: "Tìm hiểu cách nhập dữ liệu từ file Excel hoặc CSV",
      steps: {
        openImport: {
          title: "Mở công cụ nhập",
          description:
            "Nhấp nút 'Nhập' trên trang danh sách để bắt đầu. Bạn có thể nhập tối đa 1000 bản ghi mỗi lần.",
        },
        downloadTemplate: {
          title: "Tải mẫu",
          description:
            "Tải file mẫu để xem định dạng đúng. Điền dữ liệu của bạn theo cấu trúc mẫu.",
        },
        uploadFile: {
          title: "Tải file lên",
          description:
            "Kéo thả file vào đây hoặc nhấp để chọn. Định dạng hỗ trợ: Excel (.xlsx) và CSV.",
        },
        mapColumns: {
          title: "Ánh xạ cột",
          description:
            "Ghép cột trong file với các trường hệ thống. Hệ thống sẽ tự động ghép dựa trên tên cột. Trường bắt buộc đánh dấu *.",
        },
        previewData: {
          title: "Xem trước dữ liệu",
          description:
            "Xem lại dữ liệu trước khi nhập. Các dòng lỗi được đánh dấu đỏ với thông báo lỗi. Sửa trước khi tiếp tục.",
        },
        importResults: {
          title: "Kết quả nhập",
          description:
            "Xem tóm tắt hiển thị số bản ghi thành công và thất bại. Tải báo cáo lỗi để sửa và nhập lại.",
        },
      },
    },

    // Lifecycle States Tour
    lifecycleStates: {
      title: "Trạng thái vòng đời",
      description: "Hiểu cách bản ghi chuyển qua các trạng thái khác nhau",
      steps: {
        stateDisplay: {
          title: "Hiển thị trạng thái",
          description:
            "Thanh vòng đời hiển thị trạng thái hiện tại và tiến độ. Dấu tích xanh là trạng thái đã hoàn thành, trạng thái được đánh dấu là hiện tại.",
        },
        currentState: {
          title: "Trạng thái hiện tại",
          description:
            "Mỗi trạng thái có quy tắc riêng về hành động khả dụng và dữ liệu có thể sửa đổi. Một số trường có thể bị khóa.",
        },
        promoteAction: {
          title: "Chuyển trạng thái",
          description:
            "Khi có sẵn, nhấp 'Chuyển trạng thái' để đưa bản ghi sang trạng thái tiếp theo. Điều này có thể kích hoạt công việc hoặc thông báo.",
        },
        stateHistory: {
          title: "Lịch sử trạng thái",
          description:
            "Xem lịch sử đầy đủ các thay đổi trạng thái, bao gồm ai đã thay đổi và khi nào.",
        },
      },
    },

    // Column Management Tour
    columnManagement: {
      title: "Tùy chỉnh bảng",
      description: "Tìm hiểu cách tùy chỉnh cột và chế độ xem bảng",
      steps: {
        viewToggle: {
          title: "Chuyển chế độ xem",
          description:
            "Chuyển đổi giữa chế độ bảng (hàng chi tiết) và chế độ thẻ (thẻ trực quan) bằng các nút này.",
        },
        columnSettings: {
          title: "Cài đặt cột",
          description:
            "Nhấp biểu tượng cài đặt để mở cấu hình cột. Tại đây bạn có thể hiện, ẩn hoặc sắp xếp lại cột.",
        },
        toggleColumns: {
          title: "Hiện/Ẩn cột",
          description:
            "Chọn hoặc bỏ chọn cột để hiện hoặc ẩn. Tùy chọn của bạn được lưu tự động.",
        },
        columnOrder: {
          title: "Sắp xếp cột",
          description:
            "Kéo thả cột để thay đổi thứ tự. Thứ tự mới sẽ được ghi nhớ cho lần truy cập tiếp theo.",
        },
        resetDefault: {
          title: "Đặt lại mặc định",
          description:
            "Nhấp 'Đặt lại' để khôi phục cấu hình cột ban đầu nếu bạn muốn làm lại.",
        },
      },
    },

    // Dashboard Overview Tour
    dashboardOverview: {
      title: "Tổng quan Dashboard",
      description: "Tìm hiểu cách đọc và sử dụng các chỉ số trên dashboard",
      steps: {
        kpiCards: {
          title: "Các chỉ số chính",
          description:
            "Các thẻ này hiển thị chỉ số hiệu suất chính. Nhấp vào bất kỳ thẻ nào để xem chi tiết.",
        },
        charts: {
          title: "Biểu đồ",
          description:
            "Biểu diễn trực quan dữ liệu của bạn. Di chuột qua các phần tử để xem giá trị cụ thể.",
        },
        pendingTasks: {
          title: "Công việc chờ xử lý",
          description:
            "Công việc đang chờ bạn. Nhấp vào công việc để mở, hoặc 'Xem tất cả' để xem hộp thư đầy đủ.",
        },
      },
    },
  },

  // Contextual Help
  contextualHelp: {
    lifecycle: {
      title: "Về trạng thái vòng đời",
      content:
        "Bản ghi chuyển qua các trạng thái từ đầu đến cuối. Mỗi trạng thái có quy tắc riêng về hành động khả dụng.",
    },
    workflow: {
      title: "Về quy trình làm việc",
      content:
        "Quy trình tự động hóa bằng cách tạo công việc và phân công đúng người. Hoàn thành công việc để đưa mục tiến lên.",
    },
    import: {
      title: "Về nhập dữ liệu",
      content:
        "Nhập dữ liệu từ file Excel hoặc CSV. Tải mẫu trước để đảm bảo dữ liệu đúng định dạng.",
    },
    relationships: {
      title: "Về các mục liên quan",
      content:
        "Bản ghi có thể liên kết với các bản ghi khác. Sử dụng tab quan hệ để xem và quản lý các liên kết này.",
    },
    columns: {
      title: "Về cài đặt cột",
      content:
        "Tùy chỉnh cột hiển thị trong bảng. Tùy chọn được lưu và ghi nhớ cho lần truy cập tiếp theo.",
    },
  },

  // Actions
  actions: {
    startTour: "Bắt đầu",
    skipTour: "Bỏ qua",
    nextStep: "Tiếp theo",
    previousStep: "Quay lại",
    finish: "Hoàn tất",
    restartTour: "Bắt đầu lại",
    gotIt: "Đã hiểu!",
    close: "Đóng",
    learnMore: "Tìm hiểu thêm",
  },

  // Categories
  categories: {
    essential: {
      title: "Tính năng cơ bản",
      description: "Các tính năng bạn sử dụng hàng ngày",
    },
    dataManagement: {
      title: "Quản lý dữ liệu",
      description: "Làm việc với bản ghi và dữ liệu",
    },
    workflow: {
      title: "Quy trình & Công việc",
      description: "Quản lý quy trình nghiệp vụ",
    },
    customization: {
      title: "Tùy chỉnh",
      description: "Cá nhân hóa không gian làm việc",
    },
  },
};
